export default "__VITE_ASSET__DNCAPv7x__"